<svg viewBox="0 0 84 24">
  <circle cx="18" cy="12" r="6"></circle>
  <circle cx="18" cy="12" r="6"></circle>
  <circle cx="42" cy="12" r="6"></circle>
  <circle cx="66" cy="12" r="6"></circle>
</svg>
